<template>
  <div class="home">
    <div class="leftMenu" v-show="baseInit">
      <div class="logo">
        <img src="../assets/home/ic_logo_big.png" height="25px" width="25px" />
      </div>
      <div class="appBox">
        <div
          v-for="(item, index) in apps"
          :key="'apps' + index"
          style="margin-bottom: 18px"
        >
          <div
            :id="item.appName"
            class="appButtonBox"
            @click="to(item.activeRule, index)"
          >
            <!-- :class="
              currentAppName == item.appName
                ? 'appButtonBox activeApp'
                : 'appButtonBox'
            " -->
            <!-- :style="{background: ($actions.getGlobalState("currentAppName")==item.appName)?'##0049a0':'unset'}" -->
            <template v-if="item.icon && item.icon.length > 0">
              <div class="iconAndName">
                <div
                  :class="
                    currentAppName == item.appName
                      ? 'appIcon activeApp'
                      : 'appIcon'
                  "
                >
                  <img :src="item.icon" alt="" width="38px" height="38px" />
                </div>
                <div class="appName">
                  <span>{{ item.appName }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <span>{{ item.webRoot.substring(0, 3) }}</span>
            </template>
          </div>
        </div>
      </div>
      <div class="versionBox">
        <div>
          <i
            style="color: white; cursor: pointer"
            @click="getVersion()"
            class="iconfont icon-tishi"
          />
        </div>
        <div>
          <i
            style="color: white; cursor: pointer"
            @click="menuTreeshow()"
            :class="menuTree ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
          />
        </div>
      </div>
    </div>
    <div style="width: 60px" v-show="baseInit"></div>
    <div
      class="container"
      :style="{ width: baseInit ? 'calc(100% - 60px)' : '100%' }"
    >
      <div class="topHeader" v-show="topHeaderRender && baseInit">
        <!-- <topHeader
          :externApps="externApps"
          :languageList="languageList"
          :orgDomains="orgDomains"
        ></topHeader> -->
      </div>
      <div
        class="homeContainer"
        id="home"
        :style="{ height: baseInit ? 'calc(100% - 50px)' : '100%' }"
      ></div>
    </div>
    <div class="fixedTopHeader" v-show="topHeaderRender && baseInit">
      <topHeader
        :externApps="externApps"
        :languageList="languageList"
        :orgDomains="orgDomains"
      ></topHeader>
    </div>
    <el-dialog
      width="30%"
      :title="$t('appsVersion.versionList')"
      :visible.sync="dialogStatu.version"
      custom-class="dialogStyle"
      :close-on-click-modal="false"
    >
      <div class="versionDialogStyle">
        <div class="appVersionBox">
          <div
            v-for="(item, index) in Object.keys(appsVersion)"
            :key="index"
            class="appVersionBoxItem"
          >
            <div class="appNameBox">
              <span>{{ item }}</span>
            </div>
            <div>
              <span>:</span>
            </div>
            <div class="appVersionBox">
              <span>{{ appsVersion[item] }}</span>
            </div>
          </div>
        </div>
        <div class="copyrightBox">
          <p>
            {{ $t("hanshow.copyright") }}
            <i class="iconfont icon-banquan"></i>
            {{ $t("hanshow.year") }}
            {{ $t("hanshow.product") }}
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setDefaultMountApp, start, registerMicroApps } from "qiankun";
import topHeader from "@/components/topHeader.vue";
import { isEmpty, contains } from "@/utils/utils.js";
export default {
  components: { topHeader },
  computed: {
    languageList() {
      const isProduction = process.env.NODE_ENV === "production";
      // const isProduction = true;
      if (isProduction) {
        console.log(this.$store.state.config.languageList);
        return this.$store.state.config.languageList;
      }
      return window.HS_CONFIG.languageList;
    },
    currentAppName() {
      return this.$actions.getGlobalState("currentAppName");
    },
    hiddenTopHeaderPages() {
      return window.HS_CONFIG.hiddenTopHeaderPages;
    },
  },
  data() {
    return {
      menuTree: "true",
      apps: [],
      currentApp: {},
      topHeaderRender: false,

      appsVersion: "",
      dialogStatu: {
        version: false,
      },
      externApps: [],
      orgDomains: [],

      baseInit: true,
    };
  },
  created() {
    let promiseList = [];
    promiseList.push(this.getWorkBench());
    if (isEmpty(this.languageList)) {
      promiseList.push(this.getLanguageList());
    }
    Promise.all(promiseList).then(() => {
      this.toApp();
      this.topHeaderRender = true;
      let currentAppName = this.$actions.getGlobalState("currentAppName");
      console.log(this.apps);
      try {
        setDefaultMountApp(
          this.apps.find((item) => item.appName == currentAppName).activeRule[0]
        );
      } catch (error) {
        //当有异常  直接默认跳转到第一个应用
        console.log("当前出现异常");
        setDefaultMountApp(this.apps[0].activeRule[0]);
      }
    });
    // 防止在全屏页面刷新
    let url = window.location.href;
    let hashIndex = url.indexOf("#");
    let router = url.substring(hashIndex);
    if (this.hiddenTopHeaderPages.some((item) => contains(router, item))) {
      this.baseInit = false;
    } else {
      this.baseInit = true;
    }
  },
  mounted() {
    window.addEventListener("popstate", () => {
      // vue router 内部走的history pushState     hashChange监听不到， so  监听popstate
      console.log("popState, base 监听到url 变化", window.location);
      let url = window.location.href;
      let hashIndex = url.indexOf("#");
      let router = url.substring(hashIndex);
      if (this.hiddenTopHeaderPages.some((item) => contains(router, item))) {
        this.baseInit = false;
      } else {
        this.baseInit = true;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("popstate", () => {
      console.log("移除popstate 监听事件");
    });
  },

  methods: {
    getVersion() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getAppVersion()
          .then((res) => {
            if (res.resultCode == 1001) {
              this.appsVersion = res.data ?? "";
            }
            this.dialogStatu.version = true;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getWorkBench() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getWorkBench()
          .then((res) => {
            //TODO 有点复杂 后续优化
            let data = res.data;
            if (data.permissionTree) {
              Object.keys(data.permissionTree).forEach((item) => {
                let permissions = data.permissionTree[item];
                if (permissions && permissions.length > 0) {
                  this.hasChild(permissions);
                }
              });
            }

            let externApps = [];
            data.apps.forEach((item) => {
              if (!isEmpty(item.appType) && item.appType == "Template") {
                externApps.push(item);
              }
            });
            this.externApps = externApps;
            let apps = data.apps.filter(
              (item) =>
                !isEmpty(item.activeRule) &&
                !isEmpty(item.appType) &&
                !isEmpty(item.entry) &&
                item.appType == "Internal"
            );
            this.$actions.setGlobalState({
              commonData: {
                customer: data.customers, // 该用户下所有客户
                username: data.username,
                userId: data.userId,
                data: data.data,
              },
              currentUser: data.user,
              permissionTree: data.permissionTree,
            });
            if (isEmpty(apps)) {
              this.topHeaderRender = true;
              return;
            }

            apps.forEach((item) => {
              if (item.webRoot.toLowerCase() == "allstar") {
                item.appName = "System";
              }
              item.name = item.webRoot;
              item.props = {};
              item.props.getGlobalState = this.$actions.getGlobalState;
              item.props.gateway = "/proxy/" + item.webRoot;
              item.container = "#home";
            });
            this.apps = apps;

            let as = apps.find(
              (item) => item.webRoot.toLowerCase() == "allstar"
            );
            // 公共区域为空   执行默认选择， 默认选择规则，有as进as 没有默认进第一个
            if (isEmpty(this.$actions.getGlobalState("currentAppName"))) {
              //看 as情况， 有as 进as ，没有默认进第一个应用
              if (isEmpty(as)) {
                this.$actions.setGlobalState({
                  currentAppName: apps[0].appName,
                });
              } else {
                this.$actions.setGlobalState({
                  currentAppName: as.appName,
                });
              }
            }
            // 当前确保公共区域里面有数据
            this.getAdministrator(data.user.domains);

            registerMicroApps(apps, {
              beforeLoad: (app) => console.log("before load", app.name),
              beforeMount: (app) => console.log("before mount", app.name),
              beforeUnmount: (app) => console.log("unmount", app.name),
            });
            //根据 data.user.domains做  组织管理员和门店管理员的区分

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getLanguageList() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getConfigByName("systemI18n")
          .then((res) => {
            if (res.resultCode == 1001) {
              console.log(res.data);
              if (!isEmpty(res.data)) {
                this.$store.commit("config/initLanguageList", res.data.value);
              }
              resolve(res);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 权限树无用数据清空
    hasChild(data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          delete item.link;
          delete item.appId;
          delete item.createTime;
          delete item.extend;
          delete item.updateTime;
          if (item.childNodes && item.childNodes.length > 0) {
            this.hasChild(item.childNodes);
          }
        });
      }
    },
    toApp() {
      try {
        start({
          singular: false,
          prefetch: "all",
          sandbox: { experimentalStyleIsolation: true },
          fetch(url, ...args) {
            return window.fetch(url, {
              ...args,
              mode: "cors",
              // credentials: "include"
            });
          },
        });
      } catch (error) {
        //  会出现加载出现问题 ，如若currAppName 有值， 进currentAppName 如果没有，进第一个应用
        let currentAppName = this.$actions.getGlobalState("currentAppName");
        let currentApp = {};
        if (!isEmpty(currentAppName)) {
          currentApp = this.apps.find(
            (item) => item.appName.toLowerCase() == currentAppName.toLowerCase()
          );
        } else {
          currentApp = this.apps[0];
        }
        if (!isEmpty(currentApp)) {
          history.pushState(null, null, currentApp.activeRule[0]);
        } else {
          console.error("当前未接入应用");
        }
      }
    },
    menuTreeshow() {
      this.menuTree = !this.menuTree;
      this.$actions.setGlobalState({
        showMenu: this.menuTree,
      });
    },
    to(data, index) {
      history.pushState(null, null, data[0]);
      // history.forward();
      // 记录当前应用
      this.$actions.setGlobalState({
        currentAppName: this.apps[index].appName,
      });
    },

    openWindow(entry) {
      let url = entry;
      let accessToken = this.$actions.getGlobalState("accessToken");
      //加密
      // let nnnnn=aes.encrypt(accessToken);
      url += "?token=" + accessToken;
      window.open(url);
    },
    getAdministrator(domains) {
      if (domains == "**") {
        this.orgDomains = ["**"];
      } else {
        let domain = domains.split(",");
        let orgDomains = domain.filter((item) => item.indexOf("**") != -1);
        this.orgDomains = orgDomains;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activeApp {
  background: #00489e;
}
.home {
  width: 100%;
  height: 100%;
  display: flex;
  .container {
    height: 100%;
    // width: calc(100% - 60px);
    display: flex;
    flex-direction: column;
    .topHeader {
      height: 50px;
    }
    .homeContainer {
      height: calc(100% - 50px);
    }
  }
  .leftMenu {
    height: 100vh;
    width: 60px;
    background: #015ac5;
    position: fixed;
    .logo {
      //   position: relative;
      width: 60px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    .appBox {
      height: calc(100% - 42px - 38px);
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: flex-start;
      padding-top: 20px;
      align-items: center;
      .appButtonBox {
        border-radius: 8px;
        height: 60px;
        width: 40px;
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-weight: 700;
        color: white;
        .iconAndName {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          align-content: center;
          .appIcon {
            height: 46px;
            width: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            align-content: center;
            border-radius: 8px;
            img {
            }
            :hover {
              background: #00489e;
              border-radius: 8px !important;
            }
          }
          .appName {
            color: rgba(255, 255, 255, 1) !important;
            font-size: 12px !important;
            font-family: PingFangSC-Regular !important;
            text-align: center !important;
            line-height: 17px !important;
            font-weight: 300;
          }
        }
      }
    }
    .versionBox {
      border-top: 1px solid rgba(255, 255, 255, 0.29);
      position: fixed;
      bottom: 10px;
      width: 60px;
      padding-top: 8px;
      display: flex;
      justify-content: center;
      justify-content: space-evenly;
    }
  }
}

.versionDialogStyle {
  display: flex;
  flex-direction: column;
  .appVersionBox {
    width: 100%;
    .appVersionBoxItem {
      display: flex;
      flex: 1;
      margin: 20px 0;
      .appNameBox {
        width: 48.5%;
        text-align: right;
        margin-right: 5px;
      }
      .appVersionBox {
        width: 48.5%;
        text-align: left;
        margin-left: 5px;
      }
    }
  }
  .copyrightBox {
    margin: 20px 0 0 0;
    width: 100%;
    color: rgba(0, 0, 0, 0.6);
  }
}

::v-deep .dialogStyle {
  text-align: center;
  border-radius: 10px !important;
  .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #e9e9e9;
  }
}

.fixedTopHeader {
  position: fixed;
  left: 60px;
  top: 0px;
  width: calc(100% - 60px);
  height: 50px;
  z-index: 2000;
  background-color: white;
}
</style>
